import { useEffect } from 'react';

import { useGetPeerNotification } from '@givebacks/api/notification';
import { PeerTypes } from '@givebacks/api/store';
import { ClickableOptionsCard } from 'core/Components';
import { useFormListValidator } from 'core/Hooks';
import { RadioMantine } from 'ui';
import { useForm } from 'ui/Form';

export type DonationNotificationsFormType = {
  notifications: string;
};

const DonationNotificationsForm = ({
  causeId,
  participantId,
  peerType,
}: {
  causeId: string;
  participantId: string;
  peerType: PeerTypes;
}) => {
  const { data: notification, isFetched } = useGetPeerNotification({
    causeId,
    peerId: participantId,
    peerType,
  });

  const form = useForm<DonationNotificationsFormType>({});

  const handleChange = (value: string) => {
    form.setFieldValue('notifications', value);
  };

  useEffect(() => {
    if (isFetched) {
      form.initialize({ notifications: notification ? 'true' : 'false' });
    }
  }, [form, isFetched, notification]);

  useFormListValidator({ form, id: 'donationNotifications' });

  return (
    <RadioMantine.Group {...form.getInputProps('notifications')}>
      <ClickableOptionsCard>
        <ClickableOptionsCard.Row
          title="Allow donation notifications"
          subtitle="Notifications will be sent to your email notifying you when a donation has been made on your behalf."
          rightSection={<RadioMantine value="true" />}
          onClick={() => handleChange('true')}
        />
        <ClickableOptionsCard.Row
          title="Don't allow donation notifications"
          subtitle="Donations made on your behalf will always appear on your participant page when you're logged in."
          rightSection={<RadioMantine value="false" />}
          onClick={() => handleChange('false')}
        />
      </ClickableOptionsCard>
    </RadioMantine.Group>
  );
};

export { DonationNotificationsForm };
